import * as d3 from "d3";
import dataD3ComponentMixin from "./data-d3-component-mixin.js";

// Handles the graph concepts (x/y/axis/clipping)
export default {
  mixins: [dataD3ComponentMixin],
  data() {
    return { yAxis: new Object() };
  },
  methods: {
    getYAxis(legend) {
      if (typeof this.yAxis[legend] === "undefined" && !this.yAxis[legend]) {
        this.yAxis[legend] = {};
      }
      return this.yAxis[legend];
    },
    calcyRanges(flux_structure) {
      // Updates x and y ranges given the current time and values
      let yAxis = flux_structure.yAxis;

      let yMargin;
      let min;
      let max;
      if (this.attributes.ymin && this.attributes.ymax) {
        min = parseInt(this.attributes.ymin);
        max = parseInt(this.attributes.ymax);
      } else {
        min = d3.min(flux_structure.data, function (row) {
          return row.number_value;
        });
        max = d3.max(flux_structure.data, function (row) {
          return row.number_value;
        });
      }

      if (yAxis.min === undefined || min < yAxis.min) {
        yAxis.min = min;
      }
      if (yAxis.max === undefined || max > yAxis.max) yAxis.max = max;

      yMargin = ((max - min) * 10) / 100;
      var yMarginMin = yAxis.min - yMargin;
      var yMarginMax = yAxis.max + yMargin;
      // Scale the range of the data
      // X range based on player
      // TODO: make y range configurable
      if (this.config.attributes.y_inversion) {
        yAxis.d3_yRange.domain([yMarginMax, yMarginMin]);
      } else {
        yAxis.d3_yRange.domain([yMarginMin, yMarginMax]);
      }

      /*if (this.Is_double_ordonnee) {
        this.d3_y1Range.domain([min1 - y1Margin, max1 + y1Margin]);
      }*/
      // GRID ELABORATION

      // set the ranges for GRID
      yAxis.grid_yRange.domain([yMarginMin, yMarginMax]);
    },
    calcxRanges() {
      // Updates x and y ranges given the current time and values

      let minX, maxX;
      if (this.attributes.xmin && this.attributes.xmax) {
        minX = parseInt(this.attributes.xmin);
        maxX = parseInt(this.attributes.xmax);
      } else {
        Object.keys(this.objectData).forEach((key) => {
          let flux_structure = this.objectData[key];
          let newvalueX = d3.min(flux_structure.data, (row) => {
            return JSON.parse(row.raw_value)[this.Is_data_abscisse];
          });
          minX =
            typeof minX === "undefined" || minX > newvalueX ? newvalueX : minX;
        }, this);
        Object.keys(this.objectData).forEach((key) => {
          let flux_structure = this.objectData[key];
          let newvalueX = d3.max(flux_structure.data, (row) => {
            return JSON.parse(row.raw_value)[this.Is_data_abscisse];
          });
          maxX =
            typeof maxX === "undefined" || maxX < newvalueX ? newvalueX : maxX;
        }, this);
      }

      // Scale the range of the data
      // X range based on player
      const xRange = !this.Is_data_abscisse
        ? [1, this.time_range]
        : [minX, maxX];
      this.d3_xRange.domain(xRange);

      // GRID ELABORATION
      // set the ranges for GRID
      this.grid_xRange.domain(xRange);
    },
    D3prepareYAxis(flux_structure) {
      let yAxis = this.getYAxis(flux_structure.attributes.legend_y);
      flux_structure.yAxis = yAxis;
      if (yAxis.d3_yRange === undefined) {
        // Set the ranges
        yAxis.d3_yRange = d3.scaleLinear().range([this.graphHeight, 0]);
        yAxis.grid_yRange = d3.scaleLinear().range([this.graphHeight, 0]);

        // Define the axes
        // ticks() define number of step on the axes

        if (flux_structure.attributes.ordinate_position == "right") {
          yAxis.d3_yAxis = d3.axisRight(yAxis.d3_yRange).ticks(5);
        } else {
          yAxis.d3_yAxis = d3.axisLeft(yAxis.d3_yRange).ticks(5);
        }
        yAxis.grid_yAxis = d3.axisLeft(yAxis.grid_yRange).ticks(5);

        // Inserts the yaxis into the DOM
        yAxis.dom_yAxis = this.dom_canvas
          .append("g")
          .attr("class", "dom_yAxis")
          .style("font-size", "3px")
          .style("font-weight", "300");

        if (flux_structure.attributes.scale_position == "right") {
          yAxis.dom_yAxis.attr(
            "transform",
            "translate( " + this.graphWidth + ", 0 )"
          );
        }

        // Insert a legend for the axis Y for each graph. the text of legend is an attributes of histogram element in BDD.
        yAxis.dom_yAxis
          .append("text")
          .attr("fill", flux_structure.attributes.color)
          .attr("transform", "rotate(-25)")
          .attr("y", () => {
            if (
              flux_structure.attributes.ordinate_position == "right" &&
              flux_structure.attributes.scale_position != "right"
            ) {
              return 6;
            } else {
              return -6;
            }
          })
          .attr("dy", "0.71em")
          .style("text-anchor", "start")
          .text(`${flux_structure.attributes.legend_y}`);

        // grid example: https://bl.ocks.org/d3noob/c506ac45617cf9ed39337f99f8511218
        // add the Y gridlines
        yAxis.grid_dom_yAxis = this.dom_canvas
          .append("g")
          .attr("class", "grid")
          .style(
            "opacity",
            flux_structure.attributes.grid_opacity
              ? `${flux_structure.attributes.grid_opacity}`
              : "1"
          );

        this.prepareFlux(flux_structure);
      }
    },
    D3GraphPrepare() {
      this.D3Prepare();
      /*
      if (this.Is_double_ordonnee) {
        this.d3_y1Range = d3.scaleLinear().range([this.graphHeight, 0]);
        this.d3_y1Axis = d3.axisRight(this.d3_y1Range).ticks(5);
        // Inserts the yaxis into the DOM
        this.dom_y1Axis = this.dom_canvas
          .append("g")
          .attr("class", "dom_y1Axis")
          .style("font-size", "5px")
          .style("font-weight", "700");
      }*/
      // Set the ranges
      if (!this.typeScale) {
        this.d3_xRange = d3.scaleLinear().range([0, this.graphWidth]);
        this.grid_xRange = d3.scaleLinear().range([0, this.graphWidth]);
      } else {
        this.d3_xRange = d3.scaleLog().base(10).range([0, this.graphWidth]);
        this.grid_xRange = d3.scaleLog().base(10).range([0, this.graphWidth]);
      }

      // Define the axes
      // ticks() define number of step on the axes
      this.d3_xAxis = d3.axisBottom(this.d3_xRange).ticks(5);
      this.grid_xAxis = d3.axisBottom(this.grid_xRange).ticks(5);

      this.calcxRanges();
      Object.keys(this.objectData).forEach((flux_identifier) => {
        let flux_structure = this.getFluxStructure(flux_identifier);
        this.calcyRanges(flux_structure);
      }, this);

      // Insert the axis elemnt into the DOM
      this.dom_xAxis = this.dom_canvas
        .append("g")
        .attr("class", "dom_xAxis")
        .attr("transform", `translate(0,${this.graphHeight})`)
        .style("font-size", "5px")
        .style("font-weight", "300");

      if (this.Is_data_abscisse) {
        this.dom_xAxis
          .append("text")
          .attr("fill", "#000")
          .attr("y", 15)
          .attr("x", this.graphWidth)
          .attr("dy", "0.71em")
          .style("text-anchor", "end")
          .text(`${this.tx(this.Is_data_abscisse)}`);
      }
      if (this.legend_x) {
        this.dom_xAxis
          .append("text")
          .attr("fill", "#000")
          .attr("y", 15)
          .attr("x", this.graphWidth)
          .attr("dy", "0.71em")
          .style("text-anchor", "end")
          .text(`${this.legend_x}`);
      }

      // add the X gridlines
      this.grid_dom_xAxis = this.dom_canvas
        .append("g")
        .attr("class", "grid")
        .attr("transform", "translate(0," + this.graphHeight + ")");

      // Clipping: clipPath: everything out of this area won't be drawn.(useful for zoom option)
      // Credits to: https://developer.mozilla.org/fr/docs/Web/SVG/Tutoriel/D%C3%A9coupages_et_masquages
      this.dom_canvas
        .append("defs")
        .append("clipPath")
        .attr("id", this.clipAreaId)
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", this.graphWidth)
        .attr("height", this.graphHeight);
    },
    D3GraphTick() {
      // Updates the axis in the DOM

      // Create a second ordinate only if the histogram (in layout) has the attribute 'second ordonnée'
      /*if (this.Is_double_ordonnee) {
        this.dom_y1Axis.call(this.d3_y1Axis);
      }*/
      this.D3Tick();

      // for zoom , scaleExtent permet de limiter les niveaux de unzoom et de zoom.

      // this.zoom = this.dom_canvas
      //   .call(
      //     d3
      //       .zoom()
      //       .scaleExtent([1, 3])
      //       .extent([[0, 0], [this.graphWidth, this.graphHeight]])
      //       .translateExtent([
      //         [0, 0],
      //         [this.graphWidth, this.graphHeight]
      //       ])
      //       .on("zoom", this.updateChart))
      // Updates the DOM for each flux (rendering)
      Object.keys(this.objectData).forEach((flux_identifier) => {
        let flux_structure = this.getFluxStructure(flux_identifier);
        this.D3prepareYAxis(flux_structure);
        flux_structure.yAxis.dom_yAxis.call(flux_structure.yAxis.d3_yAxis);
        flux_structure.yAxis.grid_dom_yAxis.call(
          flux_structure.yAxis.grid_yAxis
            .tickSize(-this.graphWidth)
            .tickFormat("")
        );
        this.calcyRanges(flux_structure);
        this.tickFlux(flux_structure);
      }, this);

      this.calcxRanges();
      this.dom_xAxis.call(this.d3_xAxis);
      this.grid_dom_xAxis.call(
        this.grid_xAxis.tickSize(-this.graphHeight).tickFormat("")
      );
    },
    updateChart() {
      // Create a update selection: bind to the new data
      var u = this.dom_canvas.selectAll(".pression");

      // Updata the line
      u.enter()
        .append("path")
        .merge(u)
        .transition()
        .duration(500)
        .attr("fill", "none")
        .attr("stroke", "steelblue")
        .attr("opacity", 1);
    },
  },
  computed: {
    clipAreaId() {
      return `${this.getId()}ClipArea`;
    },
    clipAreaURL() {
      return `url(#${this.clipAreaId})`;
    },
  },
};
